import React, { useState, useEffect } from "react";
import { Row, Col, Image, Result } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

export default function IconsList(props) {
  const [warningIconIndex, setwarningIconIndex] = useState(0);
  const [warningIconsList, setwarningIconsList] = useState([]);
  const [warningIconsInfo, setwarningIconsInfo] = useState("");
  const [firstResponderNotes, setFirstResponderNotes] = useState("");

  useEffect(() => {
    const { firstResponderNotes, warningIcons } = props;
    if (firstResponderNotes) {
      setFirstResponderNotes(firstResponderNotes);
    } else {
      setFirstResponderNotes("");
    }
    if (warningIcons) {
      setwarningIconsList(warningIcons);
    } else {
      setwarningIconsList([]);
    }
    if (props?.warningIconsInfo) {
      setwarningIconsInfo(props?.warningIconsInfo);
    } else {
      setwarningIconsInfo("");
    }
  }, [props]);

  const warningInfoSwap = (currentWarningIconIndex) => {
    let info = warningIconsList[currentWarningIconIndex];
    setwarningIconsInfo(info);
    setwarningIconIndex(currentWarningIconIndex);
  };

  return (
    <div>
      <Row justify="space-between">
        <Col>
          {warningIconIndex !== 0 && (
            <ArrowLeftOutlined
              style={{
                fontSize: "22px",
                color: "#6a347d",
                cursor: "pointer",
              }}
              onClick={() => warningInfoSwap(warningIconIndex - 1)}
            />
          )}
        </Col>

        <Col>
          <div onClick={() => props?.handleClose()}>
            <span
              style={{
                fontSize: "18px",
                color: "tomato",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Close
            </span>
          </div>
        </Col>

        <Col>
          {warningIconsList &&
            warningIconsList.length !== warningIconIndex + 1 && (
              <ArrowRightOutlined
                style={{
                  fontSize: "22px",
                  color: "#6a347d",
                  cursor: "pointer",
                }}
                onClick={() => warningInfoSwap(warningIconIndex + 1)}
              />
            )}
        </Col>
      </Row>

      {firstResponderNotes?.length > 0 && (
        <div
          style={{
            padding: "10px",
            background: "#f5f5f5",
            borderRadius: "5px",
            textAlign: "center",
            margin: "10px 20px -10px",
          }}
        >
          <span>{firstResponderNotes}</span>
        </div>
      )}

      <Result
        icon={
          <Image
            src={warningIconsInfo.securedFileUrl}
            width={84}
            height={84}
            style={{
              borderRadius: "10px",
              background: "#d5d5d5",
              objectFit: "cover",
            }}
          />
        }
        status="success"
        title={warningIconsInfo.optionName ? warningIconsInfo.optionName : ""}
        subTitle={
          warningIconsInfo.description ? warningIconsInfo.description : ""
        }
      />
      <h4 style={{ textAlign: "center", marginTop: "-50px" }}>
        {warningIconsInfo?.answers?.length > 0 &&
          warningIconsInfo?.answers?.map((item, index) => (
            <span style={{ marginRight: "5px" }}>
              {item?.answer}
              {index !== warningIconsInfo?.answers?.length - 1 ? "," : " "}
            </span>
          ))}
      </h4>
    </div>
  );
}
